export enum AnchorHref {
  General = 'general',
  Roomtypes = 'roomtypes',
  Facilities = 'facilities',
  PracticalInfo = 'practical-info',
  Reviews = 'reviews',
  Destination = 'destination',
}
